
<template>
  <div class="foot-layout">
    <div class="foot-wrap">
      <div class="foot-l">
        <p>亿实软件科技有限公司</p>
        <p>电话：6555916</p>
        <p>地址：福建省厦门市软件园三期C05栋503-1单元</p>
        <p @click="turnBA">闽ICP备10007820号-16</p>
        <p @click="turnGA">闽公网安备35021102000738</p>
      </div>
      <div class="foot-r">
        <img src="../../assets/images/83FBBCA8-B91A-4985-B122-DF450EE3DD26.png" />
        <p class="gzh">关注公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
  components: {},

  props: {},

  watch: {},

  data() {
    return {};
  },

  computed: {},

  methods: {
    turnBA() {
      window.open("http://beian.miit.gov.cn");
    },
    turnGA() {
        window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35021102000738");
    }
  },
  mounted() {}
};
</script>

<style lang="less">
.foot-layout {
  background-color: #4d97ff;
  .foot-wrap {
    width: 1230px;
    margin: 0 auto;
    display: flex;
    padding: 30px 0;
    .foot-l {
      flex: 1;
      p {
        color: #fff;
        margin: 0;
        // font-weight: bold;
        line-height: 24px;
      }
    }
    .foot-r {
      img {
        width: 60px;
        height: 60px;
        vertical-align: -3px;
        margin: -10px 10px;
      }
      .gzh {
        text-align: center;
        display: block;
        margin-top: 10px;
        padding: 5px 0 0;
        color: #fff;
        font-weight: bold;
      }
    }
  }
}
</style>

